import { E_MenuType, IMenuListItem, IUserMenu } from '@/api/moudules/system.types'
import _ from 'lodash'
import Vue from 'vue'

export function collectMenuId(menus: IUserMenu[], collect: number[]) {
    _.each(menus, menu => {
        collect.push(menu.id)
        if (!_.isEmpty(menu.children)) {
            collectMenuId(menu.children, collect)
        }
    })
}

export function collectMenus<T extends { children: T[] }>(menus: T[], collect: T[]) {
    _.each(menus, menu => {
        collect.push(menu)
        collectMenus(menu.children, collect)
    })
}


/**
 * https://vue-treeselect.js.org/ 
 */
export function toSelectMenuOptions(menus: IMenuListItem[]) {
    return _.flatMap(menus, menu => {
        const {
            children,
            menuType,
            menuName,
            ...resetContent
        } = menu
        if (menuType === E_MenuType.Button) {
            return []
        }
        return [{
            ...resetContent,
            label: menuName,
            children: toSelectMenuOptions(children)
        }]
    })
}
/**
 $t("enum.E_MenuItem.LargeScreen")
$t("enum.E_MenuItem.OnlineMonitor")
$t("enum.E_MenuItem.WaveDiagnosis")
$t("enum.E_MenuItem.Eigenvalue_15")
$t("enum.E_MenuItem.ModifyParams")
$t("enum.E_MenuItem.healthTesting")
$t("enum.E_MenuItem.alarmReport")
$t("enum.E_MenuItem.faultRecord")
$t("enum.E_MenuItem.Handle")
$t("enum.E_MenuItem.Delete")
$t("enum.E_MenuItem.AiAlarmReport")
$t("enum.E_MenuItem.faultAnalysis")
$t("enum.E_MenuItem.DeviceCollectAdded")
$t("enum.E_MenuItem.HistorySuggest")
$t("enum.E_MenuItem.faultDelete")
$t("enum.E_MenuItem.DataQuery")
$t("enum.E_MenuItem.DataRealtime")
$t("enum.E_MenuItem.WeekReport")
$t("enum.E_MenuItem.WeekReportPage")
$t("enum.E_MenuItem.WeekReportHistory")
$t("enum.E_MenuItem.WeekReportDetail")
$t("enum.E_MenuItem.WeekReportEdit")
$t("enum.E_MenuItem.WeekReportDownloadPdf")
$t("enum.E_MenuItem.WeekReportDelete")
$t("enum.E_MenuItem.DataHistory")
$t("enum.E_MenuItem.Export")
$t("enum.E_MenuItem.WeekReportRVT50")
$t("enum.E_MenuItem.Upload")
$t("enum.E_MenuItem.Download")
$t("enum.E_MenuItem.WaveSpectrum")
$t("enum.E_MenuItem.SettingManager")
$t("enum.E_MenuItem.EquipmentList")
$t("enum.E_MenuItem.MappingManager")
$t("enum.E_MenuItem.AddPoint")
$t("enum.E_MenuItem.ModifyPoint")
$t("enum.E_MenuItem.Unbind")
$t("enum.E_MenuItem.AIParams")
$t("enum.E_MenuItem.Bind")
$t("enum.E_MenuItem.collectCard")
$t("enum.E_MenuItem.subcompanyManagement")
$t("enum.E_MenuItem.addModifySubCompany")
$t("enum.E_MenuItem.addCompanyImage")
$t("enum.E_MenuItem.addAreaImage")
$t("enum.E_MenuItem.areaMark")
$t("enum.E_MenuItem.addEditArea")
$t("enum.E_MenuItem.deleteSubCompany")
$t("enum.E_MenuItem.gatewayManagement")
$t("enum.E_MenuItem.Add")
$t("enum.E_MenuItem.ModelManagement")
$t("enum.E_MenuItem.addModifyModel")
$t("enum.E_MenuItem.addDeviceType")
$t("enum.E_MenuItem.deleteModel")
$t("enum.E_MenuItem.equipmentManagement")
$t("enum.E_MenuItem.Import")
$t("enum.E_MenuItem.mappingManagement")
$t("enum.E_MenuItem.sensorManagement")
$t("enum.E_MenuItem.batchEdit")
$t("enum.E_MenuItem.equipmentPartManagement")
$t("enum.E_MenuItem.bearingManagement")
$t("enum.E_MenuItem.addModify")
$t("enum.E_MenuItem.thresholdManagement")
$t("enum.E_MenuItem.thresholdExport")
$t("enum.E_MenuItem.thresholdImport")
$t("enum.E_MenuItem.alarmLamp")
$t("enum.E_MenuItem.closeList")
$t("enum.E_MenuItem.alarmLampClose")
$t("enum.E_MenuItem.alarmLampEnable")
$t("enum.E_MenuItem.thresholdSetting")
$t("enum.E_MenuItem.systemManagement")
$t("enum.E_MenuItem.userManagement")
$t("enum.E_MenuItem.userStatusOpenClose")
$t("enum.E_MenuItem.assignPermission")
$t("enum.E_MenuItem.resetPassword")
$t("enum.E_MenuItem.assignRole")
$t("enum.E_MenuItem.wechatBindQuery")
$t("enum.E_MenuItem.wechatUnbind")
$t("enum.E_MenuItem.permissionManagement")
$t("enum.E_MenuItem.detail")
$t("enum.E_MenuItem.emailManagement")
$t("enum.E_MenuItem.templateAdd")
$t("enum.E_MenuItem.templateDetail")
$t("enum.E_MenuItem.templateUpdate")
$t("enum.E_MenuItem.templateDelete")
$t("enum.E_MenuItem.roleManagement")
$t("enum.E_MenuItem.inspection")
$t("enum.E_MenuItem.inspectionDanger")
$t("enum.E_MenuItem.inspectionDangerLibrary")
$t("enum.E_MenuItem.inspectionGroup")
$t("enum.E_MenuItem.inspectionLine")
$t("enum.E_MenuItem.inspectionPoint")
$t("enum.E_MenuItem.inspectionRepair")
$t("enum.E_MenuItem.inspectionRepairLibrary")
$t("enum.E_MenuItem.inspectionStandard")
$t("enum.E_MenuItem.inspectionTask")
$t("enum.E_MenuItem.instantInspection")
$t("enum.E_MenuItem.inspectionTaskPlan")
$t("enum.E_MenuItem.inspectUpkeep")
$t("enum.E_MenuItem.inspectUpkeepLibrary")
$t("enum.E_MenuItem.inspectWeeklyReport")
$t("enum.E_MenuItem.weeklyReportHistory")
$t("enum.E_MenuItem.weeklyReportEdit")
$t("enum.E_MenuItem.weeklyReportDelete")
$t("enum.E_MenuItem.vb31UptoCloud")
$t("enum.E_MenuItem.equipmentList")
$t("enum.E_MenuItem.PointSave")
$t("enum.E_MenuItem.PointDelete")
$t("enum.E_MenuItem.equipment")
$t("enum.E_MenuItem.wave")
$t("enum.E_MenuItem.alarmHistory")
$t("enum.E_MenuItem.platformRemote")
$t("enum.E_MenuItem.collect")
$t("enum.E_MenuItem.point")
$t("enum.E_MenuItem.transferToInspectionDanger")
$t("enum.E_MenuItem.directLink")
$t("enum.E_MenuItem.manager")
$t("enum.E_MenuItem.hasFinished")
$t("enum.E_MenuItem.hasTimeout")
$t("enum.E_MenuItem.analysisNotify")
$t("enum.E_MenuItem.alarmNotify")
$t("enum.E_MenuItem.gateway")
$t("enum.E_MenuItem.information")
$t("enum.E_MenuItem.ask")
$t("enum.E_MenuItem.news")
$t("enum.E_MenuItem.my")
$t("enum.E_MenuItem.aboutUs")
$t("enum.E_MenuItem.langageSwitch")
$t("enum.E_MenuItem.checkUpdate")
$t("enum.E_MenuItem.Modify")
$t("enum.E_MenuItem.New")
$t("enum.E_MenuItem.InspectionTask1")
$t("enum.E_MenuItem.IntelligentDiagnosis")
$t("enum.E_MenuItem.PlatformHandle")
$t("enum.E_MenuItem.FaultCaseLibrary")
$t('enum.E_MenuItem.WeekReport2')
$t('enum.E_MenuItem.gatewaySetting')
$t('enum.E_MenuItem.modelAlarmReport')

$t('enum.E_MenuItem.sensorThresholdManagement')
$t('enum.E_MenuItem.gasThresholdManagement')
$t('enum.E_MenuItem.gdsThresholdManagement')

$t('enum.E_MenuItem.GasAlarm')
$t('enum.E_MenuItem.GdsAlarm')


$t('enum.E_MenuItem.AlarmCenter')
$t('enum.E_MenuItem.EquipmentAlarm')
$t('enum.E_MenuItem.SensorAlarm')
$t('enum.E_MenuItem.PushAlarm')
$t('enum.E_MenuItem.TempVibAlarm')
$t('enum.E_MenuItem.BatteryAlarm')
$t('enum.E_MenuItem.AngleAlarm')
$t('enum.E_MenuItem.OfflineAlarm')
$t('enum.E_MenuItem.MailPush')
$t('enum.E_MenuItem.WechatPush')
$t('enum.E_MenuItem.VoicePush')

$t('enum.E_MenuItem.aiHelper')
$t('enum.E_MenuItem.deviceLog')
$t('enum.E_MenuItem.largeScreenCompany')
$t('enum.E_MenuItem.WifiNetwork')
$t('enum.E_MenuItem.customerManagement_log')
$t('enum.E_MenuItem.voiceManagement')
$t('enum.E_MenuItem.compensationCoefficient')
$t('enum.E_MenuItem.temperatureCompensation')
 */
export enum E_MenuItem {
    /**
     * 全局总览
     */
    LargeScreen = "LargeScreen",

    /**
     * 总公司大屏
     */
    largeScreenCompany = "largeScreenCompany",
    /**
     * 在线监测
     */
    OnlineMonitor = "OnlineMonitor",
    /**
     * 波形诊断
     */
    WaveDiagnosis = "WaveDiagnosis",
    /**
     * 十五个特征值
     */
    Eigenvalue_15 = "Eigenvalue_15",
    /**
     * 修改参数
     */
    ModifyParams = "ModifyParams",
    /**
     * 健康评分
     */
    healthTesting = "healthTesting",

    /**
     * 智能诊断
     */
    IntelligentDiagnosis = "IntelligentDiagnosis",

    /**
     * 诊断分析
     */
    alarmReport = "alarmReport",
    /**
     * 报警记录
     */
    faultRecord = "faultRecord",
    /**
     * 处理
     */
    Handle = "Handle",
    /**
     * 删除
     */
    Delete = "Delete",
    /**
     * AI诊断
     */
    AiAlarmReport = "AiAlarmReport",
    /**
     * 模型诊断(老)
     */
    faultAnalysis = "faultAnalysis",
    /**
     * 模型诊断
     */
    modelAlarmReport = 'modelAlarmReport',
    /**
     * 设备汇总建议新增
     */
    DeviceCollectAdded = "DeviceCollectAdded",
    /**
     * 历史建议
     */
    HistorySuggest = "HistorySuggest",
    /**
     * 故障诊断删除
     */
    faultDelete = "faultDelete",
    /**
     * 数据中心
     */
    DataQuery = "DataQuery",
    /**
     * 实时数据
     */
    DataRealtime = "DataRealtime",
    /**
     * 诊断周报
     */
    WeekReport = "WeekReport",
    /**
     * 诊断周报2
     */
    WeekReport2 = "WeekReport2",
    /**
     * 周报分页
     */
    WeekReportPage = "WeekReportPage",
    /**
     * 周报历史
     */
    WeekReportHistory = "WeekReportHistory",
    /**
     * 周报详情
     */
    WeekReportDetail = "WeekReportDetail",
    /**
     * 编辑周报
     */
    WeekReportEdit = "WeekReportEdit",
    /**
     * 下载Pdf
     */
    WeekReportDownloadPdf = "WeekReportDownloadPdf",
    /**
     * 删除周报
     */
    WeekReportDelete = "WeekReportDelete",
    /**
     * 历史数据
     */
    DataHistory = "DataHistory",
    /**
     * 故障标签
     */
    FaultTagLibrary = "FaultTagLibrary",
    /**
     * 导出
     */
    Export = "Export",
    /**
     * RVT50周报
     */
    WeekReportRVT50 = "WeekReportRVT50",
    /**
     * 上传
     */
    Upload = "Upload",
    /**
     * 下载
     */
    Download = "Download",
    /**
     * 图谱分析
     */
    WaveSpectrum = "WaveSpectrum",

    /**
     * 报警中心
     */
    AlarmCenter = 'AlarmCenter',

    /**
     * 设备报警
     */
    EquipmentAlarm = 'EquipmentAlarm',
    /**
     * 传感器报警
     */
    SensorAlarm = 'SensorAlarm',
    /**
     * 报警推送
     */
    PushAlarm = 'PushAlarm',

    /**
     * 温振报警
     */
    TempVibAlarm = 'TempVibAlarm',

    /**
     * 气体报警
     */
    GasAlarm = 'GasAlarm',

    /**
     * 粉尘报警
     */
    GdsAlarm = 'GdsAlarm',

    /**
     * 电压报警
     */
    BatteryAlarm = 'BatteryAlarm',

    /**
     * 终端移位
     *
     * */
    AngleAlarm = 'AngleAlarm',

    /**
     * 离线
     */
    OfflineAlarm = 'OfflineAlarm',

    /**
     * 邮件推送
     */
    MailPush = 'MailPush',

    /**
     * 微信推送
     */
    WechatPush = 'WechatPush',

    /**
     * 语音推送
     */
    VoicePush = 'VoicePush',


    /**
     *  配置管理    
     */
    SettingManager = "SettingManager",
    /**
     *  设备总览    
     */
    EquipmentList = "EquipmentList",
    /**
     *  测点管理
     */
    MappingManager = "MappingManager",
    /**
     *  添加测点
     */
    AddPoint = "AddPoint",
    /**
     *  修改测点
     */
    ModifyPoint = "ModifyPoint",
    /**
     *  解绑
     */
    Unbind = "Unbind",
    /**
     *  AI诊断参数
     */
    AIParams = "AIParams",
    /**
     *  绑定
     */
    Bind = "Bind",
    /**
     *  数采器
     */
    collectCard = "collectCard",
    /**
     *  子公司管理
     */
    subcompanyManagement = "subcompanyManagement",
    /**
     *  新增/修改子公司
     */
    addModifySubCompany = "addModifySubCompany",
    /**
     *  上传公司图
     */
    addCompanyImage = "addCompanyImage",
    /**
     *  上传区域图
     */
    addAreaImage = "addAreaImage",
    /**
     *  区域标点
     */
    areaMark = "areaMark",
    /**
     *  新增 / 修改区域
     */
    addEditArea = "addEditArea",
    /**
     *  删除子公司
     */
    deleteSubCompany = "deleteSubCompany",
    /**
     *  网关管理
     */
    gatewayManagement = "gatewayManagement",
    /**
     *  网关设置
     */
    gatewaySetting = "gatewaySetting",
    /**
     *  添加
     */
    Add = "Add",
    /**
     *  模型管理
     */
    ModelManagement = "ModelManagement",
    /**
     *  新增 / 修改模型
     */
    addModifyModel = "addModifyModel",
    /**
     *  新增设备类型
     */
    addDeviceType = "addDeviceType",
    /**
     *  删除模型
     */
    deleteModel = "deleteModel",
    /**
     *  设备管理
     */
    equipmentManagement = "equipmentManagement",
    /**
     *  导入
     */
    Import = "Import",
    /**
     *  测点管理
     */
    mappingManagement = "mappingManagement",
    /**
     *  传感器管理
     */
    sensorManagement = "sensorManagement",
    /**
     *  批量修改
     */
    batchEdit = "batchEdit",
    /**
     *  设备部件管理
     */
    equipmentPartManagement = "equipmentPartManagement",
    /**
     *  轴承库管理
     */
    bearingManagement = "bearingManagement",
    /**
     *  添加 / 修改
     */
    addModify = "addModify",
    /**
     *  阈值管理
     */
    thresholdManagement = "thresholdManagement",
    /**
     *  阈值导出
     */
    thresholdExport = "thresholdExport",
    /**
     *  阈值导入
     */
    thresholdImport = "thresholdImport",
    /**
     *  报警灯管理
     */
    alarmLamp = "alarmLamp",
    /**
     *  关闭列表
     */
    closeList = "closeList",
    /**
     *  关闭报警灯
     */
    alarmLampClose = "alarmLampClose",
    /**
     *  启停报警灯
     */
    alarmLampEnable = "alarmLampEnable",
    /**
     *  阈值设定
     */
    thresholdSetting = "thresholdSetting",

    /**
     * 振动阈值
     */
    sensorThresholdManagement = "sensorThresholdManagement",

    /**
     * 气体阈值设定
     */
    gasThresholdManagement = "gasThresholdManagement",
    /**
     * 粉尘阈值设定
     */
    gdsThresholdManagement = "gdsThresholdManagement",

    /**
     * 设备日志
     */
    deviceLog = 'deviceLog',

    /**
     *  系统管理
     */
    systemManagement = "systemManagement",
    /**
     *  用户管理
     */
    userManagement = "userManagement",
    /**
     *  用户状态开启关闭
     */
    userStatusOpenClose = "userStatusOpenClose",
    /**
     *  分配权限
     */
    assignPermission = "assignPermission",
    /**
     *  重置密码
     */
    resetPassword = "resetPassword",
    /**
     *  分配角色
     */
    assignRole = "assignRole",
    /**
     *  微信绑定信息查询
     */
    wechatBindQuery = "wechatBindQuery",
    /**
     *  微信绑定信息解绑
     */
    wechatUnbind = "wechatUnbind",
    /**
     *  权限管理
     */
    permissionManagement = "permissionManagement",
    /**
     *  详情
     */
    detail = "detail",
    /**
     *  邮件管理
     */
    emailManagement = "emailManagement",
    /**
     *  语音管理
     */
    voiceManagement = "voiceManagement",
    /**
     * AI助手
     */
    aiHelper = 'aiHelper',
    /**
     *  添加模板
     */
    templateAdd = "templateAdd",
    /**
     *  模板详情
     */
    templateDetail = "templateDetail",
    /**
     *  更新模板
     */
    templateUpdate = "templateUpdate",
    /**
     *  删除模板
     */
    templateDelete = "templateDelete",
    /**
     *  角色管理
     */
    roleManagement = "roleManagement",
    /**
     *  点检
     */
    inspection = "inspection",
    /**
     *  隐患
     */
    inspectionDanger = "inspectionDanger",
    /**
     *  隐患库
     */
    inspectionDangerLibrary = "inspectionDangerLibrary",
    /**
     *  点检班组
     */
    inspectionGroup = "inspectionGroup",
    /**
     *  点检路线
     */
    inspectionLine = "inspectionLine",
    /**
     *  巡检点
     */
    inspectionPoint = "inspectionPoint",
    /**
     *  维修
     */
    inspectionRepair = "inspectionRepair",
    /**
     *  维修库
     */
    inspectionRepairLibrary = "inspectionRepairLibrary",
    /**
     *  点检标准
     */
    inspectionStandard = "inspectionStandard",
    /**
     *  巡检记录
     */
    inspectionTask = "inspectionTask",
    /**
     *  即时点检
     */
    instantInspection = "instantInspection",
    /**
     *  巡检任务
     */
    inspectionTaskPlan = "inspectionTaskPlan",
    /**
     *  保养
     */
    inspectUpkeep = "inspectUpkeep",
    /**
     *  保养库
     */
    inspectUpkeepLibrary = "inspectUpkeepLibrary",
    /**
     *  点检周报
     */
    inspectWeeklyReport = "inspectWeeklyReport",
    /**
     *  周报历史
     */
    weeklyReportHistory = "weeklyReportHistory",
    /**
     *  编辑周报
     */
    weeklyReportEdit = "weeklyReportEdit",
    /**
     *  删除周报
     */
    weeklyReportDelete = "weeklyReportDelete",
    /**
     *  VB31组网上云
     */
    vb31UptoCloud = "vb31UptoCloud",
    /**
     *  设备列表
     */
    equipmentList = "equipmentList",
    /**
     *  保存测点
     */
    PointSave = "PointSave",
    /**
     *  删除测点
     */
    PointDelete = "PointDelete",
    /**
     *  特征值
     */
    equipment = "equipment",
    /**
     *  波形
     */
    wave = "wave",
    /**
     *  报警记录
     */
    alarmHistory = "alarmHistory",
    /**
     *  平台远程
     */
    platformRemote = "platformRemote",
    /**
     *  汇总
     */
    collect = "collect",
    /**
     * 测点
     */
    point = "point",
    /**
     * 转隐患按钮
     */
    transferToInspectionDanger = "transferToInspectionDanger",
    /**
     *  直连
     */
    directLink = "directLink",
    /**
     *  管理
     */
    manager = "manager",
    /**
     *  已完成
     */
    hasFinished = "hasFinished",
    /**
     *  已超时
     */
    hasTimeout = "hasTimeout",
    /**
     *  诊断通知
     */
    analysisNotify = "analysisNotify",
    /**
     *  报警通知
     */
    alarmNotify = "alarmNotify",
    /**
     *  网关
     */
    gateway = "gateway",
    /**
     *  资讯
     */
    information = "information",
    /**
     *  咨询/推荐
     */
    ask = "ask",
    /**
     * 新闻
     */
    news = "news",
    /**
     *  我的
     */
    my = "my",
    /**
     * 关于我们
     */
    aboutUs = "aboutUs",
    /**
     * 中英文切换
     */
    langageSwitch = "langageSwitch",
    /**
     *  检查更新
     */
    checkUpdate = "checkUpdate",
    /**
     * 修改
     */
    Modify = "Modify",
    /**
     * 新增
     */
    New = "New",
    /**
     * 点检任务
     */
    InspectionTask1 = "InspectionTask1",
    /**
     * 平台处理
     */
    PlatformHandle = "PlatformHandle",

    /**
     * 故障案例
     */
    FaultCaseLibrary = 'FaultCaseLibrary',

    /**
     * 厂区图片
     */
    FactoryImage = 'FactoryImage',

    /**
     * 巡检点管理
     */
    inspectManagement = 'inspectManagement',

    /**
     * 巡检配置
     */
    inspectConfig = 'inspectConfig',

    /**
     * 经验建模
     */
    libManager = 'libManager',

    /**
     * 组网
     */
    WifiNetwork = 'WifiNetwork',

    /**
     * 多时域
     */
    TimeDomainWave = 'TimeDomainWave',

    /**
     * 配置管理
     */
    configManager = 'configManager',

    /**
     * 设备管理
     */
    DeviceManager = 'DeviceManager',

    /**
     * 硬件管理
     */
    hardwareManagement = 'hardwareManagement',

    /**
     * 阈值模板
     */
    thresholdTemplate = 'thresholdTemplate',

    /**
     * 启停阈值
     */
    equipmentRunThreshold = 'equipmentRunThreshold',

    /**
     * 补偿系数
     */
    compensationCoefficient = 'compensationCoefficient',

    /**
     * 温度补偿
     */
    temperatureCompensation = 'temperatureCompensation',


    mappingImport = "mappingImport",

    mappingBindImport = "mappingBindImport",

    sensorImport = 'sensorImport',

    sensorExport = 'sensorExport',

    /**
     * 手动诊断
     */
    _btn_modelHandleDiagnosis = '_btn_modelHandleDiagnosis',
    /**
     * 排序
     */
    _btn_sort = '_btn_sort',
    /**
     * 重置密码
     */
    _btn_resetPassword = '_btn_resetPassword',


    /**
     * 日志管理
     */
    customerManagement_log = 'customerManagement_log'

}

let cnTable: Record<string, E_MenuItem> = null

function collectTable(vm: Vue) {
    let res = {}
    _.each(E_MenuItem, value => {
        let key = `enum.E_MenuItem.` + value
        let label = vm.$t(key, 'cn') as string
        res[label] = value
    })
    return res
}

export function menuItemFromString(s: string, vm: Vue): E_MenuItem {
    if (cnTable === null) {
        cnTable = collectTable(vm)
    }
    return cnTable[s]
}
